module.exports = __webpack_public_path__ + "img/ecosystem-bg.c4f3941a.png";